import { render, staticRenderFns } from "./ProductCardView.vue?vue&type=template&id=518b21cd&scoped=true"
import script from "./ProductCardView.vue?vue&type=script&lang=js"
export * from "./ProductCardView.vue?vue&type=script&lang=js"
import style0 from "./ProductCardView.vue?vue&type=style&index=0&id=518b21cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b21cd",
  null
  
)

export default component.exports